import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 px-4 border-t border-brown-light/20 bg-cream-dark text-center" data-id="element-95">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-96">
        <p className="font-serif text-xs md:text-sm text-brown-dark/50 leading-relaxed" data-id="element-97">
          Dies ist ein persönlicher Erfahrungsbericht. Ergebnisse können
          individuell variieren. Bei anhaltenden Beschwerden bitte einen
          Tierarzt aufsuchen.
        </p>
        <p className="font-serif text-xs text-brown-dark/40" data-id="element-98">
          © 2026 Napftagebuch. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}